<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
    ref="baseDelete"
  >
    <p> Você tem certeza que deseja deletar a tabela preço produto do insumo <b>{{this.entry.item.name}}</b>?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(subculture) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_TABLE_PRICE_PRODUCT_MUTATION,
          variables: {
            id: subculture.id,
          }
        })
        .then(response => {
          var errors = response.data.destroyTablePriceProduct.errors
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_TABLE_PRICE_PRODUCT_MUTATION = gql `
  mutation($id: ID!) {
    destroyTablePriceProduct(id: $id) {
      tablePriceProduct {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>